import { EService } from '../../../../repositories/auction/v2/get-top-bets-by-announcement';

export const SERVICE_MAP: { [service: string]: EService } = {
  top3: EService.Top3,
  premium: EService.Premium,
  paid: EService.Paid,
  'paid+highlight': EService.Paid,
  'premium+highlight': EService.Premium,
};

export const TOP_BETS_COUNT = 5;
